import { DirectionsI } from '../interfaces/directions.interface'
import { DirectionsService } from '../services/directions.service'
import {
    CreateCompanyDirectionPayload,
    DirectionsCreateDirectionResponseT,
    DirectionsCreatePayloadT,
    DirectionsGetCitiesForDirectionsResponseT,
    DirectionsGetListParamsT,
    DirectionsGetListResponseT,
    DirectionsUpdateDirectionResponseT,
    GetCompanyDirectionDetailsResponse,
    GetCompanyDirectionsListResponse,
    GetCompanyDirectionsParams,
    UpdateCompanyDirectionPayload,
} from '../types/directions.types'

const directionsService = new DirectionsService()

class DirectionsRealisation implements DirectionsI {
    getList(params: DirectionsGetListParamsT): Promise<DirectionsGetListResponseT> {
        return directionsService.getList(params)
    }

    createDirection(
        payload: DirectionsCreatePayloadT
    ): Promise<DirectionsCreateDirectionResponseT> {
        return directionsService.createDirection(payload)
    }

    updateDirection(
        direction_id: number,
        zoneId: number,
        isNearbyCities: number
    ): Promise<DirectionsUpdateDirectionResponseT> {
        return directionsService.updateDirection(direction_id, zoneId, isNearbyCities)
    }

    getCitiesForDirections(): Promise<DirectionsGetCitiesForDirectionsResponseT> {
        return directionsService.getCitiesForDirections()
    }

    importFromExcel(form_data: FormData): Promise<void> {
        return directionsService.importFromExcel(form_data)
    }

    deleteDirection(id: number): Promise<void> {
        return directionsService.deleteDirection(id)
    }

    getCompanyDirections(params: GetCompanyDirectionsParams): Promise<GetCompanyDirectionsListResponse> {
        return directionsService.getCompanyDirections(params)
    }

    getCompanyDirectionDetails(companyDirectionId: number): Promise<GetCompanyDirectionDetailsResponse> {
        return directionsService.getCompanyDirectionDetails(companyDirectionId)
    }

    createCompanyDirection(payload: CreateCompanyDirectionPayload): Promise<void> {
        return directionsService.createCompanyDirection(payload)
    }

    updateCompanyDirection(companyDirectionId: number, payload: UpdateCompanyDirectionPayload): Promise<void> {
        return directionsService.updateCompanyDirection(companyDirectionId, payload)
    }

    deleteCompanyDirection(companyDirectionId: number): Promise<void> {
        return directionsService.deleteCompanyDirection(companyDirectionId)
    }
}

export const directions = new DirectionsRealisation()
